import get from 'get-value'
import { getAPIInternalBaseURL } from '../../../NonReact/constants/ApiConstants'
import {
    BroadworksSSOConfigDTO,
    FeaturesConfigDTO,
    MicrosoftSSOConfigDTO,
    MiscAppConfigDTO,
    VersionsConfigDTO
} from '../../../NonReact/Types/Types'
import { requestGetJSON } from '../../../NonReact/common/API/REST/RESTAPIClient'
import { JSONResponse } from '../../../NonReact/common/Types/Types'

const FEATURES_FILE_NAME: string = 'features'
const VERSIONS_FILE_NAME: string = 'versions'
const BROADWORKS_SSO_FILE_NAME: string = 'broadworks-sso-config'
const MICROSOFT_SSO_FILE_NAME: string = 'microsoft-sso-config'
const MISC_APP_CONFIG_FILE_NAME: string = 'miscAppConfig'

export const getConfig = <T extends unknown>(config: string): Promise<JSONResponse<T>> =>
    requestGetJSON(getAPIInternalBaseURL().appendPathParams('genericConfig', config), {
        cacheTime: 500000
    })

export const getFeaturesConfig = (): Promise<JSONResponse<FeaturesConfigDTO>> =>
    getConfig<FeaturesConfigDTO>(FEATURES_FILE_NAME)

export const getFeaturesConfigValue = (key: string): Promise<boolean> =>
    getFeaturesConfig().then(
        (response: JSONResponse<FeaturesConfigDTO>): boolean => !!get(response ?? {}, key) ?? false
    )

export const getVersionsConfig = (): Promise<JSONResponse<VersionsConfigDTO>> =>
    getConfig<VersionsConfigDTO>(VERSIONS_FILE_NAME)

export const getBroadworksSSOConfig = (): Promise<JSONResponse<BroadworksSSOConfigDTO>> =>
    getConfig<BroadworksSSOConfigDTO>(BROADWORKS_SSO_FILE_NAME)

export const getMicrosoftSSOConfig = (): Promise<JSONResponse<MicrosoftSSOConfigDTO>> =>
    getConfig<MicrosoftSSOConfigDTO>(MICROSOFT_SSO_FILE_NAME)

export const getMiscAppConfig = (): Promise<JSONResponse<MiscAppConfigDTO>> =>
    getConfig<MiscAppConfigDTO>(MISC_APP_CONFIG_FILE_NAME)
